import { getItemFromStorage, isAtLocalStorage, saveItemInStorage } from "../../helper/storage";
import { isTokenValid } from "../../helper/tokenValidation";
import { apiRefreshLogin } from "./login";

export const baseUrl = process.env.REACT_APP_E2W_API;

export const buildHeaders = (authorization = "") => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  }

  const auth = authorization || getItemFromStorage("TOKEN");

  if (auth) {
    headers["Authorization"] = `Bearer ${auth}`;
  }

  return headers;
}

const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const getResponseOrThrow = async response => {
  if (response.ok) {
    return response.json();
  }
  const json = await response.json().catch(() => ({ msg: response.statusText }));
  if (json?.message === "Community not found") {
    localStorage.removeItem("COMPANY_ID");
    sessionStorage.removeItem("COMPANY_ID");
    if (!window.location.pathname.includes("/selecionar-empresa")) {
      window.location.href = "/selecionar-empresa";
    }
    return Promise.reject(new Error("Community not found"));
  }
  throw json;
};

export const urlFilters = (url, filters) => {
  if (filters === undefined) {
    return url;
  }

  const filtersKeys = Object.keys(filters);

  filtersKeys.forEach(key => {
    const keyValue = filters[key];
    if (keyValue !== '' && keyValue !== " ") {
      const symbol = url.includes('?') ? '&' : '?';
      url += `${symbol}${key}=${keyValue}`
    }
  });

  return url;
}

let refreshTokenPromise = null;

export const performTokenRefresh = async () => {
  if (refreshTokenPromise) {
    return refreshTokenPromise;
  }

  refreshTokenPromise = (async () => {
    try {
      let refreshToken = getItemFromStorage("REFRESH_TOKEN");

      if (!refreshToken || refreshToken === "null" || refreshToken === "undefined") {
        throw new Error("No valid refresh token found");
      }

      const json = await apiRefreshLogin(refreshToken);

      const keepLogged = isAtLocalStorage("REFRESH_TOKEN");
      if (json.refreshToken) {
        saveItemInStorage("REFRESH_TOKEN", json.refreshToken, keepLogged);
      }
      saveItemInStorage("TOKEN", json.token, keepLogged);
      saveItemInStorage("LAST_LOGIN", Date.now(), keepLogged);

      return json.token;
    } finally {
      refreshTokenPromise = null;
    }
  })();

  return refreshTokenPromise;
};

const clearSessionAndRedirect = () => {
  ['TOKEN', 'REFRESH_TOKEN', 'LAST_LOGIN', 'MANAGER_ID', 'COMPANY_ID', 'USER_ID'].forEach(k => {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  });
  if (!window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
};

export const authorizedFetch = async (url, init) => {
  const doRequest = (token) => {
    const newInit = { ...(init || {}) };
    newInit.headers = {
      ...(init && init.headers ? init.headers : {}),
      ...buildHeaders(token)
    };
    return fetch(url, newInit);
  };

  if (!isTokenValid()) {
    try {
      await performTokenRefresh();
      const newToken = getItemFromStorage("TOKEN");
      return await doRequest(newToken);
    } catch {
      clearSessionAndRedirect();
      return Promise.reject(new Error('Session expired'));
    }
  }

  const response = await doRequest();

  if (response.status === 401 || response.status === 403) {
    try {
      await performTokenRefresh();
      const newToken = getItemFromStorage("TOKEN");
      const retryResponse = await doRequest(newToken);

      if (retryResponse.status === 401 || retryResponse.status === 403) {
        clearSessionAndRedirect();
        return Promise.reject(new Error('Session expired'));
      }

      return retryResponse;
    } catch {
      clearSessionAndRedirect();
      return Promise.reject(new Error('Session expired'));
    }
  }

  return response;
};
